// ** Reducers Imports
import { ProjectApi } from "../shared/api/ProjectApi";
import { mileStoneSlice } from "./slice/milestone.slice";
import { MileStoneApi } from "../shared/api/MileStoneApi";
import { AuthApi } from "../shared/api/AuthApi";
import { UserApi } from "../shared/api/UserApi";
import { auth } from "./slice/auth.slice";
import modalSlice from "./slice/modal.slice";
import { PermissionsApi } from "../shared/api/PermissionsApi";
import { projectSlice } from "./slice/project.slice";
import { ProfileApi } from "../shared/api/ProfileApi";
import { AssignUserApi } from "../shared/api/AssignUserApi";
import { BoardApi } from "../shared/api/BoardApi";
import { boardReducer } from "./slice/board.slice";
import userSlice from "./slice/assignUser.slice";
import { PermissionsSlice } from "./slice/permissions.slice";
import { NotificationApi } from "../shared/api/NotificationApi";
import notificationSlice from "./slice/notification.slice";
import { BhuApi } from "../shared/api/BhuApi";
import { TaskApi } from "../shared/api/Taskapi";
import { AnnouncementsApi } from "../shared/api/AnnouncementsApi";
import { DocumentApi } from "../shared/api/DocumentApi";
import { ChartApi } from "../shared/api/ChartApi";
import { CalendarApi } from "../shared/api/Calendar.Api";
import { DashboardApi } from "../shared/api/DashboardApi";
import { CapaApi } from "../shared/api/CapaApi";
import PageSlice from "./slice/page.slice";
import { GoalApi } from "../shared/api/GoalsApi";
import { CardApi } from "../shared/api/CardApi";
import { ReviewsApi } from "../shared/api/Reviews.Api";
import { DRIPApi } from "../shared/api/DR-IPApi";
import { CommentApi } from "../shared/api/CommentApi";
import { ToDoApi } from "../shared/api/ToDoApi";
import { ProductionFileLoadingApi } from "../shared/api/ProductionFileLoadingApi";
import { EmailSettingsApi } from "../shared/api/EmailSettingsApi";
import { ProcurementApi } from "../shared/api/ProcurementApi";
import { ChatApi } from "../shared/api/ChatApi";
import { AiAssistantApi } from "../shared/api/AiAssistantApi";
import { PushNotificationApi } from "../shared/api/PushNotificationApi";

const rootReducer = {
  [auth.reducerPath]: auth.reducer,
  [AuthApi.reducerPath]: AuthApi.reducer,
  [projectSlice.reducerPath]: projectSlice.reducer,
  [ProjectApi.reducerPath]: ProjectApi.reducer,
  [mileStoneSlice.reducerPath]: mileStoneSlice.reducer,
  [MileStoneApi.reducerPath]: MileStoneApi.reducer,
  [UserApi.reducerPath]: UserApi.reducer,
  [PermissionsApi.reducerPath]: PermissionsApi.reducer,
  modal: modalSlice,
  board: boardReducer,
  users: userSlice,
  [ProfileApi.reducerPath]: ProfileApi.reducer,
  [AssignUserApi.reducerPath]: AssignUserApi.reducer,
  [BoardApi.reducerPath]: BoardApi.reducer,
  [PermissionsSlice.reducerPath]: PermissionsSlice.reducer,
  [NotificationApi.reducerPath]: NotificationApi.reducer,
  notification: notificationSlice.reducer,
  [BhuApi.reducerPath]: BhuApi.reducer,
  [TaskApi.reducerPath]: TaskApi.reducer,
  [CapaApi.reducerPath]: CapaApi.reducer,
  [AnnouncementsApi.reducerPath]: AnnouncementsApi.reducer,
  [DocumentApi.reducerPath]: DocumentApi.reducer,
  [ChartApi.reducerPath]: ChartApi.reducer,
  [CalendarApi.reducerPath]: CalendarApi.reducer,
  [DashboardApi.reducerPath]: DashboardApi.reducer,
  [GoalApi.reducerPath]: GoalApi.reducer,
  [CardApi.reducerPath]: CardApi.reducer,
  [ReviewsApi.reducerPath]: ReviewsApi.reducer,
  [DRIPApi.reducerPath]: DRIPApi.reducer,
  page: PageSlice,
  [CommentApi.reducerPath]: CommentApi.reducer,
  [ToDoApi.reducerPath]: ToDoApi.reducer,
  [ProductionFileLoadingApi.reducerPath]: ProductionFileLoadingApi.reducer,
  [EmailSettingsApi.reducerPath]: EmailSettingsApi.reducer,
  [ProcurementApi.reducerPath]: ProcurementApi.reducer,
  [ChatApi.reducerPath]: ChatApi.reducer,
  [AiAssistantApi.reducerPath]: AiAssistantApi.reducer,
  [PushNotificationApi.reducerPath]: PushNotificationApi.reducer
};

export default rootReducer;


